export enum ROLE {
  Yonetici = 'YONETICI',
  Tapu = 'TAPU',
  User = 'USER',
}
